import Breadcrumbs from '../../src/components/Breadcrumbs';
import React, { useState, useEffect, useMemo } from "react";
import '../styles/ClientDebtSummary.css'; // Optional, for styling
import Swal from 'sweetalert2';


const SettlementVault = () => {

  // useEffect(() => {
  //   Swal.fire({
  //       icon: "warning",
  //       title: "Reminder to all users",
  //       text: "This page is currently intended for testing only. For any concerns, please reach out to the development team.",
  //       confirmButtonColor: '#A5CC2D', 
  //     });
  // }, []);
    
  const [activeTab, setActiveTab] = useState('tab1');
  
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [useApiData, setUseApiData] = useState(false);
  const [apiError, setApiError] = useState(null);

  const [tab1State, setTab1State] = useState({
    selectedLegal: 'All',
    selectedIsSettled: 'Yes',
    selectedClientStatus: ['All'],
    selectedAssignedTo: ['All'],
    selectedSettlementNegotiators: ['All'],
    selectedCreditorStatus: ['All'],
    selectedOfferStatus: ['All'],
    selectedEPFRemainingRange: 'All',
    isAssignedToDropdownOpen: false,
    isSettlementNegotiatorsDropdownOpen: false,
    isCreditorStatusDropdownOpen: false,
    isOfferStatusDropdownOpen: false,
    isClientStatusDropdownOpen: false,
    originalCreditorSearch: '',
    currentCreditorSearch: '',
    contactIDSearch: '',
    contactNameSearch: '',
    currentPage: 1,
    itemsPerPage: 25,
    sortConfig: { key: null, direction: 'asc' },
    columnOrder: [
      'contactID', 'contactName', 'clientStatus', 'originalCreditor', 'currentCreditor', 
      'legal', 'preLegal', 'creditorStatus', 'originalBalance', 'currentBalance',
      'settlementAmount', 'settlementPercentage', 'offerStatus', 'programFeePercent',
      'totalEPF', 'epfOpen', 'epfRemaining', 'numCreditors', 
      'numCreditorsNotSettled', 'settledDebts', 'negotiatorRep', 'settlementNegotiator',
      'balanceLastUpdated', 'currentEscrowBalance', 'pendingBalance', 'isSettled',
      'daysDelinquent', 'debtFeePercent', 'legalNegotiator'
    ],
    draggedColumn: null
  });

  const [tab2State, setTab2State] = useState({
    selectedLegal: 'All',
    selectedIsSettled: 'Yes',
    selectedClientStatus: ['All'],
    selectedAssignedTo: ['All'],
    selectedSettlementNegotiators: ['All'],
    selectedCreditorStatus: ['All'],
    selectedOfferStatus: ['All'],
    selectedEPFRemainingRange: 'All',
    isAssignedToDropdownOpen: false,
    isSettlementNegotiatorsDropdownOpen: false,
    isCreditorStatusDropdownOpen: false,
    isOfferStatusDropdownOpen: false,
    isClientStatusDropdownOpen: false,
    originalCreditorSearch: '',
    currentCreditorSearch: '',
    contactIDSearch: '',
    contactNameSearch: '',
    currentPage: 1,
    itemsPerPage: 25,
    sortConfig: { key: null, direction: 'asc' },
    columnOrder: [
      'contactID', 'contactName', 'clientStatus', 
      'legal', 'creditorStatus', 'numCreditors', 
      'numCreditorsNotSettled', 'settledDebts', 'negotiatorRep', 'settlementNegotiator', 
      'balanceLastUpdated', 'currentEscrowBalance', 'pendingBalance', 'isSettled',
      'daysDelinquent', 'debtFeePercent', 'legalNegotiator'
    ],
    draggedColumn: null
  });

  const getCurrentTabState = () => {
    return activeTab === 'tab1' ? tab1State : tab2State;
  };

  const updateCurrentTabState = (updates) => {
    if (activeTab === 'tab1') {
      setTab1State(prev => ({ ...prev, ...updates }));
    } else {
      setTab2State(prev => ({ ...prev, ...updates }));
    }
  };

  const columnDefinitions = {
    contactID: { name: 'Contact ID', width: '100px' },
    contactName: { name: 'Contact Name', width: '150px' },
    clientStatus: { name: 'Client Status', width: '120px' },
    originalCreditor: { name: 'Original Creditor', width: '150px' },
    currentCreditor: { name: 'Current Creditor', width: '150px' },
    legal: { name: 'Legal', width: '60px' },
    preLegal: { name: 'Pre-Legal', width: '80px' },
    creditorStatus: { name: 'Creditor Status', width: '120px' },
    originalBalance: { name: 'Original Balance', width: '130px' },
    currentBalance: { name: 'Current Balance', width: '130px' },
    settlementAmount: { name: 'Settlement Amount', width: '140px' },
    settlementPercentage: { name: 'Settlement %', width: '110px' },
    offerStatus: { name: 'Offer Status', width: '120px' },
    programFeePercent: { name: 'Program Fee %', width: '120px' },
    totalEPF: { name: 'Total EPF', width: '100px' },
    epfOpen: { name: 'EPF Open', width: '100px' },
    epfRemaining: { name: 'EPF Remaining', width: '120px' },
    numCreditors: { name: '# of Creditors', width: '100px' },
    numCreditorsNotSettled: { name: '# Not Settled', width: '110px' },
    settledDebts: { name: 'Settled Debts', width: '110px' },
    negotiatorRep: { name: 'Negotiator Rep', width: '130px' },
    settlementNegotiator: { name: 'Settlement Negotiator', width: '160px' },
    balanceLastUpdated: { name: 'Balance Updated', width: '140px' },
    currentEscrowBalance: { name: 'Current Escrow', width: '130px' },
    pendingBalance: { name: 'Pending Balance', width: '130px' },
    isSettled: { name: 'Is Settled', width: '90px' },
    daysDelinquent: { name: 'Days Delinquent', width: '120px' },
    debtFeePercent: { name: 'Debt Fee %', width: '100px' },
    legalNegotiator: { name: 'Legal Negotiator', width: '140px' }
  };

  const legalOptions = ['All', 'Yes', 'No'];
  const isSettledOptions = ['All', 'Yes', 'No'];
  const epfRemainingRanges = ['All', '$0', '$250', '$500', '$1000', '$2000'];

  const parseCurrencyValue = (currencyString) => {
    if (!currencyString || currencyString === '$0') return 0;
    const cleanValue = String(currencyString).replace(/[$,]/g, '');
    const numValue = parseFloat(cleanValue);
    return isNaN(numValue) ? 0 : numValue;
  };

  const formatCurrency = (value) => {
    if (!value && value !== 0) return '$0.00';
    return `$${Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
  };

  const formatPercentage = (value) => {
    if (!value && value !== 0) return '0.0%';
    return `${Number(value).toFixed(1)}%`;
  };

  const dropdownOptions = useMemo(() => {
    if (!useApiData || apiData.length === 0) {
      return {
        clientStatus: ['All'],
        assignedTo: ['All'],
        settlementNegotiator: ['All'],
        creditorStatus: ['All'],
        offerStatus: ['All']
      };
    }

    const getUniqueValues = (key) => {
      const values = [...new Set(apiData.map(item => item[key]).filter(val => val && val !== ''))].sort();
      return ['All', ...values];
    };

    const excludedClientStatuses = [
      '1st Payment Pending',
      '1st Payment NSF',
      'Balboa – Transfer Completed',
      'Test Clients'
    ];

    const filteredClientStatusValues = getUniqueValues('clientStatus').filter(status => !excludedClientStatuses.includes(status));

    return {
      clientStatus: filteredClientStatusValues.length > 0 ? filteredClientStatusValues : ['All'],
      assignedTo: getUniqueValues('negotiatorRep'),
      settlementNegotiator: getUniqueValues('settlementNegotiator'),
      creditorStatus: getUniqueValues('creditorStatus'),
      offerStatus: getUniqueValues('offerStatus')
    };
  }, [apiData, useApiData]);

  useEffect(() => {
    console.log('Loaded API data sample:', apiData.slice(0, 5));
    handleSubmitData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const currentState = getCurrentTabState();
      if (currentState.isAssignedToDropdownOpen && !event.target.closest('[data-dropdown="assigned-to"]')) {
        updateCurrentTabState({ isAssignedToDropdownOpen: false });
      }
      if (currentState.isSettlementNegotiatorsDropdownOpen && !event.target.closest('[data-dropdown="settlement-negotiators"]')) {
        updateCurrentTabState({ isSettlementNegotiatorsDropdownOpen: false });
      }
      if (currentState.isCreditorStatusDropdownOpen && !event.target.closest('[data-dropdown="creditor-status"]')) {
        updateCurrentTabState({ isCreditorStatusDropdownOpen: false });
      }
      if (currentState.isOfferStatusDropdownOpen && !event.target.closest('[data-dropdown="offer-status"]')) {
        updateCurrentTabState({ isOfferStatusDropdownOpen: false });
      }
      if (currentState.isClientStatusDropdownOpen && !event.target.closest('[data-dropdown="client-status"]')) {
        updateCurrentTabState({ isClientStatusDropdownOpen: false });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeTab]);

  const handleSubmitData = async () => {
    try {
      setIsLoading(true);
      setUseApiData(false);
      setApiError(null);
      
      const response = await fetch('./vault/get_settlement_vault_data.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status === 'success' && result.data) {
        // Map API field names to component field names
        const mappedData = result.data.map((item, index) => ({
          id: index + 1,
          contactID: item.ContactId,
          contactName: item.ContactName || '',
          clientStatus: item.ClientStatus || '',
          originalCreditor: item.OriginalCreditor || '',
          currentCreditor: item.CurrentCreditor || '',
          legal: item.Legal ? 'Yes' : 'No',
          preLegal: item.PreLegal || 'No',
          creditorStatus: item.CreditorStatus || '',
          originalBalance: item.OriginalBalance || 0,
          currentBalance: item.CurrentBalance || 0,
          settlementAmount: item.SettlementAmount || 0,
          settlementPercentage: item.SettlementPercentage || 0,
          offerStatus: item.OfferStatus || '',
          programFeePercent: item.ProgramFeePercent || 0,
          totalEPF: item.EPFTotal || 0,
          epfOpen: item.EPFOpen || 0,
          epfRemaining: item.EPFRemaining || 0,
          numCreditors: item.NumberOfCreditors || 0,
          numCreditorsNotSettled: item.NumberOfCreditorsNotSettled || 0,
          settledDebts: item.SettledDebts || 0,
          negotiatorRep: item.NegotiatorRep || '',
          settlementNegotiator: item.SettlementNegotiator || '',
          balanceLastUpdated: item.BalanceLastUpdated || '',
          currentEscrowBalance: item.CurrentEscrowBalance || 0,
          pendingBalance: item.PendingBalance || 0,
          isSettled: item.IsSettled ? 'Yes' : 'No',
          daysDelinquent: item.DaysDelinquent || 0,
          debtFeePercent: item.DebtFeePercent || 0,
          legalNegotiator: item.LegalNegotiator || ''
        }));

        setApiData(mappedData);
        setUseApiData(true);
        updateCurrentTabState({ currentPage: 1 });
      } else {
        throw new Error(result.message || 'Failed to fetch data');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setApiError(error.message);
      setApiData([]);
      setUseApiData(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMultiSelectChange = (currentSelection, value) => {
    if (value === 'All') {
      return ['All'];
    } else {
      let newSelection = [...currentSelection];
      
      if (newSelection.includes('All')) {
        newSelection = newSelection.filter(item => item !== 'All');
      }
      
      if (newSelection.includes(value)) {
        newSelection = newSelection.filter(item => item !== value);
      } else {
        newSelection.push(value);
      }
      
      if (newSelection.length === 0) {
        newSelection = ['All'];
      }
      
      return newSelection;
    }
  };

  const handleClientStatusChange = (value) => {
    const currentState = getCurrentTabState();
    const newSelection = handleMultiSelectChange(currentState.selectedClientStatus, value);
    updateCurrentTabState({ selectedClientStatus: newSelection, currentPage: 1 });
  };

  const handleAssignedToChange = (value) => {
    const currentState = getCurrentTabState();
    const newSelection = handleMultiSelectChange(currentState.selectedAssignedTo, value);
    updateCurrentTabState({ selectedAssignedTo: newSelection, currentPage: 1 });
  };

  const handleSettlementNegotiatorsChange = (value) => {
    const currentState = getCurrentTabState();
    const newSelection = handleMultiSelectChange(currentState.selectedSettlementNegotiators, value);
    updateCurrentTabState({ selectedSettlementNegotiators: newSelection, currentPage: 1 });
  };

  const handleCreditorStatusChange = (value) => {
    const currentState = getCurrentTabState();
    const newSelection = handleMultiSelectChange(currentState.selectedCreditorStatus, value);
    updateCurrentTabState({ selectedCreditorStatus: newSelection, currentPage: 1 });
  };

  const handleOfferStatusChange = (value) => {
    const currentState = getCurrentTabState();
    const newSelection = handleMultiSelectChange(currentState.selectedOfferStatus, value);
    updateCurrentTabState({ selectedOfferStatus: newSelection, currentPage: 1 });
  };

  const handleSort = (key) => {
    const currentState = getCurrentTabState();
    let direction = 'asc';
    if (currentState.sortConfig.key === key && currentState.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    updateCurrentTabState({ 
      sortConfig: { key, direction },
      currentPage: 1 
    });
  };

  const handleDragStart = (e, columnKey) => {
    updateCurrentTabState({ draggedColumn: columnKey });
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, targetColumnKey) => {
    e.preventDefault();
    const currentState = getCurrentTabState();
    
    if (!currentState.draggedColumn || currentState.draggedColumn === targetColumnKey) {
      updateCurrentTabState({ draggedColumn: null });
      return;
    }

    const newColumnOrder = [...currentState.columnOrder];
    const draggedIndex = newColumnOrder.indexOf(currentState.draggedColumn);
    const targetIndex = newColumnOrder.indexOf(targetColumnKey);

    newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, currentState.draggedColumn);
    
    updateCurrentTabState({ 
      columnOrder: newColumnOrder,
      draggedColumn: null 
    });
  };

  const handleExportToExcel = () => {
    const currentState = getCurrentTabState();
    const headers = currentState.columnOrder.map(key => columnDefinitions[key].name);

    const csvRows = [];
    csvRows.push(headers.join(','));

    const filteredData = getFilteredData();
    filteredData.forEach(item => {
      const row = currentState.columnOrder.map(key => {
        let value = item[key] || '';
        
        // Format values for export
        if (['originalBalance', 'currentBalance', 'settlementAmount', 'totalEPF', 'epfOpen', 'epfRemaining', 'currentEscrowBalance', 'pendingBalance'].includes(key)) {
          value = formatCurrency(value);
        } else if (['settlementPercentage', 'programFeePercent'].includes(key)) {
          value = formatPercentage(value);
        }
        
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });
      csvRows.push(row.join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `settlement_vault_${activeTab}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFilteredData = () => {
    const currentState = getCurrentTabState();
    const displayData = useApiData ? apiData : [];
    
    let filteredData = displayData.filter(item => {
      const legalMatch = (currentState.selectedLegal === 'All' || item.legal === currentState.selectedLegal);
      const isSettledMatch = (currentState.selectedIsSettled === 'All' || item.isSettled === currentState.selectedIsSettled);
      const clientStatusMatch = currentState.selectedClientStatus.includes('All') || currentState.selectedClientStatus.includes(item.clientStatus);
      const assignedToMatch = currentState.selectedAssignedTo.includes('All') || currentState.selectedAssignedTo.includes(item.negotiatorRep);
      const settlementNegotiatorsMatch = currentState.selectedSettlementNegotiators.includes('All') || currentState.selectedSettlementNegotiators.includes(item.settlementNegotiator);
      const creditorStatusMatch = currentState.selectedCreditorStatus.includes('All') || currentState.selectedCreditorStatus.includes(item.creditorStatus);
      const offerStatusMatch = currentState.selectedOfferStatus.includes('All') || currentState.selectedOfferStatus.includes(item.offerStatus);
      
      const originalCreditorSearchMatch = currentState.originalCreditorSearch === '' || 
        (item.originalCreditor && String(item.originalCreditor).toLowerCase().includes(currentState.originalCreditorSearch.toLowerCase()));
      const currentCreditorSearchMatch = currentState.currentCreditorSearch === '' || 
        (item.currentCreditor && String(item.currentCreditor).toLowerCase().includes(currentState.currentCreditorSearch.toLowerCase()));
      const contactIDSearchMatch = currentState.contactIDSearch === '' || 
        (item.contactID && String(item.contactID).toLowerCase().includes(currentState.contactIDSearch.toLowerCase()));
      const contactNameSearchMatch = currentState.contactNameSearch === '' || 
        (item.contactName && String(item.contactName).toLowerCase().includes(currentState.contactNameSearch.toLowerCase()));
      
      let epfRemainingMatch = true;
      if (currentState.selectedEPFRemainingRange !== 'All') {
        const epfValue = typeof item.epfRemaining === 'number' ? item.epfRemaining : parseCurrencyValue(item.epfRemaining);
        const rangeValue = parseCurrencyValue(currentState.selectedEPFRemainingRange);
        epfRemainingMatch = epfValue >= rangeValue;
      }
      
      return legalMatch && isSettledMatch && clientStatusMatch && assignedToMatch && settlementNegotiatorsMatch &&
             creditorStatusMatch && offerStatusMatch &&
             originalCreditorSearchMatch && currentCreditorSearchMatch &&
             contactIDSearchMatch && contactNameSearchMatch && epfRemainingMatch;
    });
    
    if (currentState.sortConfig.key) {
      filteredData = [...filteredData].sort((a, b) => {
        const aValue = a[currentState.sortConfig.key] || '';
        const bValue = b[currentState.sortConfig.key] || '';
        
        const numericColumns = ['contactID', 'originalBalance', 'currentBalance', 'settlementAmount', 'settlementPercentage', 
                                'programFeePercent', 'totalEPF', 'epfOpen', 'epfRemaining', 'numCreditors', 
                                'numCreditorsNotSettled', 'settledDebts', 'currentEscrowBalance', 'pendingBalance'];
        if (numericColumns.includes(currentState.sortConfig.key)) {
          const aNum = parseFloat(aValue) || 0;
          const bNum = parseFloat(bValue) || 0;
          return currentState.sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        
        if (aStr < bStr) return currentState.sortConfig.direction === 'asc' ? -1 : 1;
        if (aStr > bStr) return currentState.sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    if (activeTab === 'tab2') {
      const seenContactIDs = new Set();
      filteredData = filteredData.filter(item => {
        if (seenContactIDs.has(item.contactID)) {
          return false;
        }
        seenContactIDs.add(item.contactID);
        return true;
      });
    }

    return filteredData;
  };

  const MultiSelectDropdown = ({ 
    label, 
    selectedValues, 
    options, 
    onChange, 
    isOpen, 
    setIsOpen, 
    dropdownKey 
  }) => (
    <div 
      style={{ display: 'flex', flexDirection: 'column', minWidth: '140px', position: 'relative' }}
      data-dropdown={dropdownKey}
    >
      <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
        {label} ({selectedValues.includes('All') ? 'All' : selectedValues.length} selected)
      </label>
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            padding: '3px 6px',
            fontSize: '11px',
            backgroundColor: 'white',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: '24px',
            paddingRight: '20px',
            width: '140px',
            boxSizing: 'border-box'
          }}
        >
          <span style={{ 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            color: selectedValues.includes('All') ? '#6b7280' : '#374151',
            flex: 1
          }}>
            {selectedValues.includes('All') 
              ? 'All Selected' 
              : selectedValues.length === 1 
                ? selectedValues[0]
                : `${selectedValues.length} selected`
            }
          </span>
          <span style={{
            fontSize: '10px',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            flexShrink: 0
          }}>
            ▼
          </span>
        </div>

        {isOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '140px',
            backgroundColor: 'white',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto'
          }}>
            {options.map((option, index) => (
              <div
                key={option}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange(option);
                }}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  borderBottom: index < options.length - 1 ? '1px solid #f3f4f6' : 'none',
                  backgroundColor: 'white',
                  transition: 'background-color 0.15s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                }}
              >
                <div style={{
                  width: '14px',
                  height: '14px',
                  border: '1px solid #d1d5db',
                  borderRadius: '2px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: selectedValues.includes(option) ? '#2563eb' : 'white',
                  borderColor: selectedValues.includes(option) ? '#2563eb' : '#d1d5db',
                  transition: 'all 0.15s ease',
                  flexShrink: 0
                }}>
                  {selectedValues.includes(option) && (
                    <span style={{
                      color: 'white',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      lineHeight: 1
                    }}>
                      ✓
                    </span>
                  )}
                </div>
                
                <span style={{
                  fontSize: '11px',
                  color: '#374151',
                  fontWeight: selectedValues.includes(option) ? '500' : '400',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: 1
                }}>
                  {option}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  const renderCellContent = (item, columnKey) => {
    let value = item[columnKey] || '';
    // Remove placeholder for settlementNegotiator and offerStatus if empty, leave blank as requested
    if ((columnKey === 'settlementNegotiator' || columnKey === 'offerStatus') && value === '') {
      value = '';
    }
    
    switch (columnKey) {
      case 'contactName':
        return (
          <span style={{ color: '#2563eb', textDecoration: 'underline', cursor: 'pointer' }}>
            {value}
          </span>
        );
      case 'legal':
      case 'preLegal':
        return (
          <span style={{ color: value === 'Yes' ? '#059669' : '#dc2626', fontWeight: '500' }}>
            {value}
          </span>
        );
      case 'creditorStatus':
        return (
          <span style={{
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            backgroundColor: value === 'Active' ? '#dcfce7' : value === 'Settled' ? '#dbeafe' : '#f3f4f6',
            color: value === 'Active' ? '#166534' : value === 'Settled' ? '#1e40af' : '#374151'
          }}>
            {value}
          </span>
        );
      case 'isSettled':
        return (
          <span style={{ 
            color: value === 'Yes' ? '#059669' : '#dc2626', 
            fontWeight: '500',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            backgroundColor: value === 'Yes' ? '#dcfce7' : '#fef2f2'
          }}>
            {value}
          </span>
        );
      case 'originalBalance':
      case 'currentBalance':
      case 'settlementAmount':
      case 'totalEPF':
      case 'epfOpen':
      case 'epfRemaining':
      case 'currentEscrowBalance':
      case 'pendingBalance':
        return (
          <span style={{ fontWeight: '500', color: '#111827' }}>
            {formatCurrency(value)}
          </span>
        );
      case 'settlementPercentage':
      case 'programFeePercent':
        return (
          <span style={{ fontWeight: '500', color: '#111827' }}>
            {formatPercentage(value)}
          </span>
        );
      case 'numCreditors':
      case 'numCreditorsNotSettled':
      case 'settledDebts':
      case 'contactID':
        return (
          <span style={{ textAlign: 'center', display: 'block', color: '#111827' }}>
            {value}
          </span>
        );
      default:
        return <span style={{ fontWeight: '500', color: '#111827' }}>{value}</span>;
    }
  };

  const getSortIcon = (columnKey) => {
    const currentState = getCurrentTabState();
    if (currentState.sortConfig.key !== columnKey) {
      return ' ↕';
    }
    return currentState.sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
  };

  const handlePageChange = (newPage) => {
    updateCurrentTabState({ currentPage: newPage });
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    updateCurrentTabState({ 
      itemsPerPage: newItemsPerPage,
      currentPage: 1 
    });
  };

  const getPageNumbers = (filteredData) => {
    const currentState = getCurrentTabState();
    const totalPages = Math.ceil(filteredData.length / currentState.itemsPerPage);
    const pageNumbers = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const start = Math.max(1, currentState.currentPage - Math.floor(maxVisible /2));
      const end = Math.min(totalPages, start + maxVisible - 1);
      
      if (start > 1) {
        pageNumbers.push(1);
        if (start > 2) pageNumbers.push('...');
      }
      
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
      
      if (end < totalPages) {
        if (end < totalPages - 1) pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  const renderWorklistContent = () => {
    const currentState = getCurrentTabState();
    const filteredData = getFilteredData();
    const totalPages = Math.ceil(filteredData.length / currentState.itemsPerPage);
    const startIndex = (currentState.currentPage - 1) * currentState.itemsPerPage;
    const endIndex = startIndex + currentState.itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    const selectStyle = {
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      padding: '3px 6px',
      fontSize: '11px',
      backgroundColor: 'white',
      cursor: 'pointer'
    };

    const inputStyle = {
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      padding: '3px 6px',
      fontSize: '11px',
      backgroundColor: 'white',
      width: '140px',
      boxSizing: 'border-box'
    };


    return (
      <>
        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '8px', 
          border: '1px solid #e5e7eb', 
          padding: '12px', 
          marginBottom: '12px',
          display: 'flex',
          gap: '8px',
          flexWrap: 'wrap',
          alignItems: 'end'
        }}>
          
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
            <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              Contact ID
            </label>
            <input
              type="text"
              placeholder="Search..."
              value={currentState.contactIDSearch}
              onChange={(e) => updateCurrentTabState({ contactIDSearch: e.target.value, currentPage: 1 })}
              style={inputStyle}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
            <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              Contact Name
            </label>
            <input
              type="text"
              placeholder="Search..."
              value={currentState.contactNameSearch}
              onChange={(e) => updateCurrentTabState({ contactNameSearch: e.target.value, currentPage: 1 })}
              style={inputStyle}
            />
          </div>

          <MultiSelectDropdown
            label="Client Status"
            selectedValues={currentState.selectedClientStatus}
            options={dropdownOptions.clientStatus}
            onChange={handleClientStatusChange}
            isOpen={currentState.isClientStatusDropdownOpen}
            setIsOpen={(isOpen) => updateCurrentTabState({ isClientStatusDropdownOpen: isOpen })}
            dropdownKey="client-status"
          />

          <MultiSelectDropdown
            label="Creditor Status"
            selectedValues={currentState.selectedCreditorStatus}
            options={dropdownOptions.creditorStatus}
            onChange={handleCreditorStatusChange}
            isOpen={currentState.isCreditorStatusDropdownOpen}
            setIsOpen={(isOpen) => updateCurrentTabState({ isCreditorStatusDropdownOpen: isOpen })}
            dropdownKey="creditor-status"
          />

          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
            <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              Current Creditor
            </label>
            <input
              type="text"
              placeholder="Search..."
              value={currentState.currentCreditorSearch}
              onChange={(e) => updateCurrentTabState({ currentCreditorSearch: e.target.value, currentPage: 1 })}
              style={inputStyle}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
            <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              Original Creditor
            </label>
            <input
              type="text"
              placeholder="Search..."
              value={currentState.originalCreditorSearch}
              onChange={(e) => updateCurrentTabState({ originalCreditorSearch: e.target.value, currentPage: 1 })}
              style={inputStyle}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
            <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              Legal
            </label>
            <select
              value={currentState.selectedLegal}
              onChange={(e) => updateCurrentTabState({ selectedLegal: e.target.value, currentPage: 1 })}
              style={selectStyle}
            >
              {legalOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
            <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              Is Settled
            </label>
            <select
              value={currentState.selectedIsSettled}
              onChange={(e) => updateCurrentTabState({ selectedIsSettled: e.target.value, currentPage: 1 })}
              style={selectStyle}
            >
              {isSettledOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>

          <MultiSelectDropdown
            label="Settlement Negotiator"
            selectedValues={currentState.selectedSettlementNegotiators}
            options={dropdownOptions.settlementNegotiator}
            onChange={handleSettlementNegotiatorsChange}
            isOpen={currentState.isSettlementNegotiatorsDropdownOpen}
            setIsOpen={(isOpen) => updateCurrentTabState({ isSettlementNegotiatorsDropdownOpen: isOpen })}
            dropdownKey="settlement-negotiators"
          />

          <MultiSelectDropdown
            label="Assigned To"
            selectedValues={currentState.selectedAssignedTo}
            options={dropdownOptions.assignedTo}
            onChange={handleAssignedToChange}
            isOpen={currentState.isAssignedToDropdownOpen}
            setIsOpen={(isOpen) => updateCurrentTabState({ isAssignedToDropdownOpen: isOpen })}
            dropdownKey="assigned-to"
          />

          <MultiSelectDropdown
            label="Offer Status"
            selectedValues={currentState.selectedOfferStatus}
            options={dropdownOptions.offerStatus}
            onChange={handleOfferStatusChange}
            isOpen={currentState.isOfferStatusDropdownOpen}
            setIsOpen={(isOpen) => updateCurrentTabState({ isOfferStatusDropdownOpen: isOpen })}
            dropdownKey="offer-status"
          />

          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
            <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              EPF Remaining
            </label>
            <select
              value={currentState.selectedEPFRemainingRange}
              onChange={(e) => updateCurrentTabState({ selectedEPFRemainingRange: e.target.value, currentPage: 1 })}
              style={selectStyle}
            >
              {epfRemainingRanges.map(option => (
                <option key={option} value={option}>{option === 'All' ? 'All' : `>= ${option}`}</option>
              ))}
            </select>
          </div>

          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <button
              onClick={() => {
                // Reset current tab filters to default values
                updateCurrentTabState({
                  selectedLegal: 'All',
                  selectedIsSettled: 'Yes',
                  selectedClientStatus: ['All'],
                  selectedAssignedTo: ['All'],
                  selectedSettlementNegotiators: ['All'],
                  selectedCreditorStatus: ['All'],
                  selectedOfferStatus: ['All'],
                  selectedEPFRemainingRange: 'All',
                  originalCreditorSearch: '',
                  currentCreditorSearch: '',
                  contactIDSearch: '',
                  contactNameSearch: '',
                  currentPage: 1
                });
              }}
              style={{
                backgroundColor: '#ef4444',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '4px',
                fontSize: '11px',
                border: 'none',
                cursor: 'pointer'
              }}
              title="Clear all filters"
            >
              Clear all filters
            </button>
            <button onClick={handleSubmitData}
              disabled={isLoading}
              style={{
                backgroundColor: isLoading ? '#9ca3af' : '#2563eb',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '4px',
                fontSize: '11px',
                border: 'none',
                cursor: isLoading ? 'not-allowed' : 'pointer'
              }}
            >
              {isLoading ? 'Loading...' : 'Refresh Data'}
            </button>
            
            <button
              onClick={handleExportToExcel}
              disabled={filteredData.length === 0}
              style={{
                backgroundColor: filteredData.length === 0 ? '#9ca3af' : '#059669',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '4px',
                fontSize: '11px',
                border: 'none',
                cursor: filteredData.length === 0 ? 'not-allowed' : 'pointer'
              }}
            >
              Export to Excel
            </button>
          </div>
        </div>

        {apiError && (
          <div style={{
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '12px',
            color: '#dc2626',
            fontSize: '12px'
          }}>
            <strong>Error:</strong> {apiError}
          </div>
        )}

        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          padding: '12px',
          marginBottom: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '12px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label style={{ fontSize: '12px', fontWeight: '500', color: '#374151' }}>
              Show:
            </label>
            <select
              value={currentState.itemsPerPage}
              onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
              style={{
                ...selectStyle,
                width: '70px'
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
              entries per page
            </span>
          </div>

          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            Showing {startIndex + 1} to {Math.min(endIndex, filteredData.length)} of {filteredData.length} entries
          </div>

          {totalPages > 1 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <button
                onClick={() => handlePageChange(currentState.currentPage - 1)}
                disabled={currentState.currentPage === 1}
                style={{
                  padding: '4px 8px',
                  fontSize: '11px',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  backgroundColor: currentState.currentPage === 1 ? '#f9fafb' : 'white',
                  color: currentState.currentPage === 1 ? '#9ca3af' : '#374151',
                  cursor: currentState.currentPage === 1 ? 'not-allowed' : 'pointer'
                }}
              >
                Previous
              </button>

              {getPageNumbers(filteredData).map((pageNum, index) => (
                <button
                  key={index}
                  onClick={() => typeof pageNum === 'number' && handlePageChange(pageNum)}
                  disabled={pageNum === '...'}
                  style={{
                    padding: '4px 8px',
                    fontSize: '11px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    backgroundColor: pageNum === currentState.currentPage ? '#2563eb' : 'white',
                    color: pageNum === currentState.currentPage ? 'white' : pageNum === '...' ? '#9ca3af' : '#374151',
                    cursor: pageNum === '...' ? 'default' : 'pointer',
                    fontWeight: pageNum === currentState.currentPage ? '500' : 'normal'
                  }}
                >
                  {pageNum}
                </button>
              ))}

              <button
                onClick={() => handlePageChange(currentState.currentPage + 1)}
                disabled={currentState.currentPage === totalPages}
                style={{
                  padding: '4px 8px',
                  fontSize: '11px',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  backgroundColor: currentState.currentPage === totalPages ? '#f9fafb' : 'white',
                  color: currentState.currentPage === totalPages ? '#9ca3af' : '#374151',
                  cursor: currentState.currentPage === totalPages ? 'not-allowed' : 'pointer'
                }}
              >
                Next
              </button>
            </div>
          )}
        </div>

        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '8px', 
          border: '1px solid #e5e7eb', 
          overflow: 'hidden' 
        }}>
          <div style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', margin: 0 }}>
              {isLoading ? 'Loading...' : `Results (${filteredData.length} records)`}
              {useApiData && <span style={{ color: '#059669', fontSize: '12px', marginLeft: '8px' }}>• Data Loaded</span>}
            </h2>
          </div>
          
          <div style={{
            overflow: 'auto',
            maxHeight: '60vh',
            maxWidth: '100%',
            border: '1px solid #e5e7eb'
          }}>
            <table style={{
              minWidth: '2000px',
              fontSize: '12px',
              color: '#111827'
            }}>
              <thead style={{
                backgroundColor: '#f9fafb',
                position: 'sticky',
                top: 0,
                zIndex: 10,
                borderBottom: '1px solid #d1d5db'
              }}>
                <tr>
                  {currentState.columnOrder.map((columnKey, index) => (
                    <th
                      key={columnKey}
                      draggable
                      onDragStart={(e) => handleDragStart(e, columnKey)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, columnKey)}
                      onClick={() => handleSort(columnKey)}
                      style={{
                        padding: '8px',
                        textAlign: 'left',
                        borderRight: index < currentState.columnOrder.length - 1 ? '1px solid #d1d5db' : 'none',
                        width: columnDefinitions[columnKey].width,
                        cursor: 'pointer',
                        userSelect: 'none',
                        backgroundColor: currentState.draggedColumn === columnKey ? '#e5e7eb' : '#f9fafb',
                        color: '#111827'
                      }}
                      title="Click to sort • Drag to reorder"
                    >
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>{columnDefinitions[columnKey].name}</span>
                        <span style={{ fontSize: '10px', opacity: 0.7 }}>
                          {getSortIcon(columnKey)}
                        </span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={currentState.columnOrder.length} style={{ textAlign: 'center', padding: '32px', color: '#6b7280' }}>
                      <p>Loading data from API...</p>
                    </td>
                  </tr>
                ) : paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id || index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                      {currentState.columnOrder.map((columnKey, colIndex) => (
                        <td
                          key={columnKey}
                          style={{
                            padding: '8px',
                            borderRight: colIndex < currentState.columnOrder.length - 1 ? '1px solid #e5e7eb' : 'none',
                            color: '#111827'
                          }}
                        >
                          {renderCellContent(item, columnKey)}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={currentState.columnOrder.length} style={{ textAlign: 'center', padding: '32px', color: '#6b7280' }}>
                      <p>No data available. Click "Refresh Data" to load from API.</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
     <div className="app-container">
        <div className="container">
           <h1>Settlement Vault</h1>
           <Breadcrumbs />
            <div style={{ minHeight: '50vh', backgroundColor: 'transparent', padding: '0' }}>
                <div style={{ width: '100%', margin: '0px auto' }}>

                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px 8px 0 0',
                        border: '1px solid #e5e7eb',
                        borderBottom: 'none',
                        padding: '0',
                        marginBottom: '0',
                        display: 'flex'
                        }}>
                        <button
                            onClick={() => setActiveTab('tab1')}
                            style={{
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '500',
                            border: 'none',
                            borderRadius: '8px 0 0 0',
                            cursor: 'pointer',
                            backgroundColor: activeTab === 'tab1' ? '#2563eb' : '#f9fafb',
                            color: activeTab === 'tab1' ? 'white' : '#6b7280',
                            borderRight: '1px solid #e5e7eb',
                            transition: 'all 0.2s ease'
                            }}
                        >
                            Settlement Overview
                            {useApiData && (
                            <span style={{ 
                                marginLeft: '8px', 
                                fontSize: '12px', 
                                opacity: 0.8,
                                backgroundColor: activeTab === 'tab1' ? 'rgba(255,255,255,0.2)' : '#e5e7eb',
                                padding: '2px 6px',
                                borderRadius: '12px'
                            }}>
                                {activeTab === 'tab1' ? getFilteredData().length : apiData.length}
                            </span>
                            )}
                        </button>
                        
                        <button
                            onClick={() => setActiveTab('tab2')}
                            style={{
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '500',
                            border: 'none',
                            borderRadius: '0 8px 0 0',
                            cursor: 'pointer',
                            backgroundColor: activeTab === 'tab2' ? '#2563eb' : '#f9fafb',
                            color: activeTab === 'tab2' ? 'white' : '#6b7280',
                            transition: 'all 0.2s ease'
                            }}
                        >
                            Client Summary
                            {useApiData && (
                            <span style={{ 
                                marginLeft: '8px', 
                                fontSize: '12px', 
                                opacity: 0.8,
                                backgroundColor: activeTab === 'tab2' ? 'rgba(255,255,255,0.2)' : '#e5e7eb',
                                padding: '2px 6px',
                                borderRadius: '12px'
                            }}>
                                {activeTab === 'tab2' ? getFilteredData().length : (() => {
                                const seenContactIDs = new Set();
                                return apiData.filter(item => {
                                    if (seenContactIDs.has(item.contactID)) {
                                    return false;
                                    }
                                    seenContactIDs.add(item.contactID);
                                    return true;
                                }).length;
                                })()}
                            </span>
                            )}
                        </button>
                        </div>

                        <div style={{
                        backgroundColor: 'white',
                        borderRadius: '0 0 8px 8px',
                        border: '1px solid #e5e7eb',
                        padding: '16px',
                        minHeight: '600px'
                        }}>
                        {renderWorklistContent()}
                        </div>

                        {/* Global Status Bar */}
                        <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        padding: '12px',
                        marginTop: '12px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '12px',
                        color: '#6b7280'
                        }}>
                        <div>
                            <strong>Data Status:</strong> 
                            {useApiData ? (
                            <span style={{ color: '#059669', marginLeft: '8px' }}>
                                {apiData.length} total records loaded from API successfully
                            </span>
                            ) : (
                            <span style={{ color: '#dc2626', marginLeft: '8px' }}>
                                No data loaded - Click "Refresh Data" to fetch from API
                            </span>
                            )}
                        </div>
                        
                        <div>
                            <strong>Active Tab:</strong> 
                            <span style={{ 
                            marginLeft: '8px',
                            padding: '2px 8px',
                            backgroundColor: activeTab === 'tab1' ? '#dbeafe' : '#fef3c7',
                            borderRadius: '4px',
                            fontWeight: '500'
                            }}>
                            {activeTab === 'tab1' ? 'Settlement Overview' : 'Client Summary'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
                            
            <br/> <br/> <br/> <br/>
            <label className="custom-footer">© 2025 Pacific Debt Relief. All rights reserved. </label>
            <br/> <br/> <br/> <br/>
        </div>
    </div>
  );
};

export default SettlementVault;

